import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetAgentTunnelServiceConnectedTimeResData extends ApiGenericResponse {
    last7DaysSessionConnectedTime: Map<Date, number>;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Last7DaysSessionConnectedTime) {
            this.last7DaysSessionConnectedTime = new Map<Date, number>();
            Object.keys(obj.Last7DaysSessionConnectedTime).forEach((day) => {
                this.last7DaysSessionConnectedTime.set(new Date(day), obj.Last7DaysSessionConnectedTime[day]);
            });
        }
    }
}
